import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './App.css';
import './navbar-animations.css';


// Add Google Fonts
const googleFontsElement = document.createElement('link');
googleFontsElement.rel = 'stylesheet';
googleFontsElement.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap';
document.head.appendChild(googleFontsElement);

// Add Font Awesome for icons
const fontAwesomeElement = document.createElement('link');
fontAwesomeElement.rel = 'stylesheet';
fontAwesomeElement.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css';
document.head.appendChild(fontAwesomeElement);

// Add preconnect for performance
const preconnectGoogle = document.createElement('link');
preconnectGoogle.rel = 'preconnect';
preconnectGoogle.href = 'https://fonts.googleapis.com';
document.head.appendChild(preconnectGoogle);

const preconnectGstatic = document.createElement('link');
preconnectGstatic.rel = 'preconnect';
preconnectGstatic.href = 'https://fonts.gstatic.com';
preconnectGstatic.crossOrigin = 'anonymous';
document.head.appendChild(preconnectGstatic);

// Add page transition animations
const styleElement = document.createElement('style');
styleElement.textContent = `
  .page-transition {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--dark);
    z-index: 9999;
    transform-origin: bottom;
    animation: pageTransition 1s cubic-bezier(0.77, 0, 0.175, 1) forwards;
  }

  @keyframes pageTransition {
    0% {
      transform: scaleY(1);
    }
    100% {
      transform: scaleY(0);
    }
  }
`;
document.head.appendChild(styleElement);

// Create page transition effect
const pageTransition = document.createElement('div');
pageTransition.className = 'page-transition';
document.body.appendChild(pageTransition);

// Find the root element
const rootElement = document.getElementById('root');

// Check if rootElement exists to satisfy TypeScript
if (!rootElement) {
  throw new Error('Root element not found');
}

// Create root and render app
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Add smooth scrolling
document.documentElement.style.scrollBehavior = 'smooth';

// Add scroll-triggered animations observer
window.addEventListener('DOMContentLoaded', () => {
  // Remove page transition after animation
  setTimeout(() => {
    if (pageTransition.parentNode) {
      pageTransition.parentNode.removeChild(pageTransition);
    }
  }, 1000);

  // Scroll reveal animation
  const scrollObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          scrollObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -100px 0px' }
  );

  // Apply to various elements
  const revealElements = document.querySelectorAll('.card, .service-card, .portfolio-item, .tech-card, .testimonial-card, .process-step');
  revealElements.forEach(el => {
    el.classList.add('reveal-element');
    scrollObserver.observe(el);
  });
});